import React from 'react';
import dynamic from 'next/dynamic';
import { Header } from 'components/Header';
import * as S from './styles';

const Footer = dynamic<Record<string, unknown>>(() =>
  import('components/Footer').then((module) => module.Footer)
);
const Login = dynamic<Record<string, unknown>>(() =>
  import('components/LoginFlow/Login').then((module) => module.Login)
);
const LoginByEmail = dynamic<Record<string, unknown>>(() =>
  import('components/LoginFlow/LoginByEmail').then(
    (module) => module.LoginByEmail
  )
);
const ConfirmEmail = dynamic<Record<string, unknown>>(() =>
  import('components/LoginFlow/ConfirmEmail').then(
    (module) => module.ConfirmEmail
  )
);
const CheckOtpCode = dynamic<Record<string, unknown>>(() =>
  import('components/LoginFlow/CheckOtpCode').then(
    (module) => module.CheckOtpCode
  )
);
const Register = dynamic<Record<string, unknown>>(() =>
  import('components/LoginFlow/Register').then((module) => module.Register)
);
const RemoteLine = dynamic<Record<string, unknown>>(() =>
  import('components/RemoteLine').then((module) => module.RemoteLine)
);
const UserInLineModal = dynamic<Record<string, unknown>>(() =>
  import('components/UserInLineModal').then((module) => module.UserInLineModal)
);
const ResendCode = dynamic<Record<string, unknown>>(() =>
  import('components/LoginFlow/ResendCode').then((module) => module.ResendCode)
);

export type LayoutProps = {
  children: React.ReactNode;
};

const Modals = ({ children }: { children: React.ReactNode }) => <>{children}</>;

export const Layout = ({ children }: LayoutProps) => {
  return (
    <S.Container>
      <Modals>
        <Login />
        <LoginByEmail />
        <ConfirmEmail />
        <CheckOtpCode />
        <ResendCode />
        <RemoteLine />
        <UserInLineModal />
        <Register />
      </Modals>
      <Header />
      <S.Content>{children}</S.Content>
      <Footer />
    </S.Container>
  );
};
